import {
  CompanyIdentificationCard,
  CompanyIdentificationInvitationForm,
  CompanyIdentificationLayout,
  CompanyIdentificationNavigation,
} from "src/components";

const CompanyIdentificationInviteThirdParty = () => {
  return (
    <CompanyIdentificationLayout>
      <CompanyIdentificationCard>
        <CompanyIdentificationNavigation />
        <CompanyIdentificationInvitationForm />
      </CompanyIdentificationCard>
    </CompanyIdentificationLayout>
  );
};

export default CompanyIdentificationInviteThirdParty;
